import { render, staticRenderFns } from "./InformasiDetail.vue?vue&type=template&id=2c1e2506&scoped=true&"
import script from "./InformasiDetail.vue?vue&type=script&lang=js&"
export * from "./InformasiDetail.vue?vue&type=script&lang=js&"
import style0 from "./InformasiDetail.vue?vue&type=style&index=0&id=2c1e2506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1e2506",
  null
  
)

export default component.exports